<template>
  <span class="ht" tabindex="0" @mouseenter="show($event)" @mousemove="move" @mouseleave="hide" @focus="show" @blur="hide" @click="toggle($event)">
    <slot />
    <!-- карточка переносится в body, чтобы её не обрезали таблица и прокрутка -->
    <span v-show="visible" ref="pop" class="ht__pop" role="tooltip" :style="position">
      <slot name="content" />
    </span>
  </span>
</template>

<script>
// Подсказка по наведению в стиле интерфейса (вместо стандартного title): светлая карточка с тенью, сама выбирает
// место над или под элементом и не выходит за края окна. На телефоне открывается нажатием.
export default {
  name: 'HoverTip',
  props: {
    disabled: { type: Boolean, default: false }
  },
  data() {
    return { visible: false, position: { top: '0px', left: '0px' }, pointer: null, timer: null }
  },
  mounted() {
    document.body.appendChild(this.$refs.pop)
  },
  beforeDestroy() {
    this.detach()
    const pop = this.$refs.pop
    if (pop && pop.parentNode) pop.parentNode.removeChild(pop)
  },
  methods: {
    show(event) {
      if (this.disabled || this.visible) return
      this.rememberPointer(event)
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.visible = true
        this.$nextTick(this.place)
        window.addEventListener('scroll', this.hide, true)
        window.addEventListener('resize', this.hide)
      }, 80)
    },
    hide() {
      clearTimeout(this.timer)
      this.visible = false
      this.detach()
    },
    toggle(event) {
      if (this.visible) this.hide()
      else this.show(event)
    },
    move(event) {
      this.rememberPointer(event)
      if (this.visible) this.place()
    },
    rememberPointer(event) {
      if (event && typeof event.clientX === 'number') this.pointer = { x: event.clientX, y: event.clientY }
    },
    detach() {
      window.removeEventListener('scroll', this.hide, true)
      window.removeEventListener('resize', this.hide)
    },
    place() {
      const pop = this.$refs.pop
      if (!pop) return
      const width = pop.offsetWidth
      const height = pop.offsetHeight
      const gap = 8
      const rect = this.$el.getBoundingClientRect()
      const point = this.pointer || { x: rect.left + rect.width / 2, y: rect.top }
      let top = point.y - height - gap
      if (top < gap) top = point.y + gap
      let left = point.x - width / 2
      left = Math.max(gap, Math.min(left, window.innerWidth - width - gap))
      this.position = { top: top + 'px', left: left + 'px' }
    }
  }
}
</script>

<style scoped>
.ht { outline: none; cursor: help; }
.ht__pop {
  position: fixed;
  z-index: 10000;
  display: block;
  width: max-content;
  max-width: min(380px, calc(100vw - 16px));
  padding: var(--space-6) var(--space-8);
  font-size: var(--text-sm);
  line-height: 1.35;
  color: var(--text-primary);
  background: var(--bg-surface);
  border: var(--border-width-default) solid var(--border-default);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-lg);
  pointer-events: none;
  white-space: normal;
}
</style>
